import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ef-screensaver',
    templateUrl: './ef-screensaver.component.html',
    styleUrls: ['./ef-screensaver.component.scss'],
    standalone: false
})
export class EfScreensaverComponent implements OnInit {

    constructor() { }

    @Input() showQR:string;
    @Input() showcaseContent:Array<{ type: string, element: string }>;

    ngOnInit(): void {
    }

}
